<div class="spinner__pro" *ngIf="(isLoadingMFA | async)">
  <div class="spinner__pro--content">
    <div>
      <img class="spinner__pro--op-icon" [src]="login.icon" alt="login-icon"/>
      <mat-progress-bar mode="indeterminate" class="spinner__pro--progress"></mat-progress-bar>
      <span class="spinner__pro--text spinner__pro--op-text">{{ translation }}</span>
    </div>
  </div>
</div>
